import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

import genders from 'data/genders';

export default function Gender({ member }) {
  return (

    <ValueItem
      icon="user-icon"
      label="Gender"
    >
      {genders.find((gender) => gender.value === member.gender)?.label}
    </ValueItem>
  );
}

Gender.propTypes = {
  member: PropTypes.object.isRequired,
};
